import JobTableHelper from './job-table-helper';
import jobFuncHelper from './job-functions-helper';


const JobHelpers = {
    TableMain: JobTableHelper,
    Functions: jobFuncHelper,
}

export default JobHelpers;